import db from '@/firebase/init'

export default {

    methods: {
          
        chartCallbellMonthly() {
            this.chartError = null
            if(this.chartDev.data.length < 1) {
              this.setChartError(this.$t('callbell.laststatus.none'))
              return
            }
            var data = {labels:[], cancel:[], call:[], calls:[]}
            for(var i in this.chartDev.data) {
              data.labels.push((new Date(this.chartDev.data[i].a0)).toISOString().substr(8,11).replace('T',' '));
              data.cancel.push((this.chartDev.data[i].b - this.chartDev.data[i].a0)/1000);
              data.call.push(this.chartDev.data[i].a1 == null ? 0 : (this.chartDev.data[i].a1 - this.chartDev.data[i].a0)/1000);
              data.calls.push(this.chartDev.data[i].ac);
            }
      
            this.chartOptions = {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                xAxes: [{
                  ticks: {autoSkip: false}
                }],
                yAxes: [{
                  type: 'logarithmic',
                  display: true,
                  position: 'left',
                  id: 'y-axis-1',
                  scaleLabel: {
                    display: true,
                    labelString: 's'
                  }
                }, {
                  type: 'linear',
                  display: true,
                  position: 'right',
                  id: 'y-axis-2',
                  gridLines: { drawOnChartArea: false }
                }]
              }
            }
      
            //TODO: i18n
            this.chartData = {
              type: 'line',
              labels: data.labels,
              datasets: [
                this.getChartLineData({
                  type: 'line',
                  color: 'green',
                  spec: {
                    label: 'Cancel, s',
                    data: data.cancel
                  }
                }),
                this.getChartLineData({
                  type: 'line',
                  color: '#DEC20B',
                  spec: {
                    label: 'Last call, s',
                    data: data.call,
                    pointStyle: 'rectRot'
                  }
                }),
                this.getChartLineData({
                  type: 'line',
                  color: 'red',
                  spec: {
                    label: 'Called, times',
                    data: data.calls,
                    fill: true,
                    yAxisID: 'y-axis-2'
                  }
                })
              ]
            }
      
      
          }

    }

}


// WEBPACK FOOTER //
// ./src/components/Charts/Callbell.js